module.exports = __webpack_public_path__ + "static/media/topSIdebarLogo.4dfb2503.png";